export default __webpack_public_path__ + "static/media/tag.6c1b0db6.png";